<div *transloco="let t" class="py-4">
	<h2 class="subheading-2">{{ t('printSettings.footerTitle') }}</h2>
	<form class="mt-4 flex flex-col">
		<mat-form-field [ngClass]="!isMobile ? 'mb-4' : 'mb-1 w-full'" appearance="fill">
			<mat-label>{{ t('printSettings.insertFooterTitle') }}</mat-label>
			<input [(ngModel)]="footerTitle" matInput name="title" type="text" />
		</mat-form-field>
	</form>
	<ara-editor [(model)]="footerText" [placeholder]="t('printSettings.insertFooterText')"></ara-editor>
</div>
